export const Loading = () => {
  return (
    <div className="alert alert-info">
      <p>Loading...</p>
    </div>
  );
}


